'use strict';

var _ = require('lodash');
var BookingMatrixTransformationService = function BookingMatrixTransformationService() {
  var AVAILABILITY_THRESHOLDS = [0.009, 0.249, 0.5, 0.749, 1];
  var HEAT_MAP_CLASS_NAME = 'heat-map-';
  var CARRIED_OVER_VALUE_CLASS = 'rm-jqx-grid-cell-carried-over-value';
  function transformRtpData(newEntry, entry, bookingMatrixMode) {
    if (!entry.daysToDepartureDataPoints || bookingMatrixMode === '') {
      return false;
    }
    var lastCumulativeValue = null;
    _.forEachRight(entry.daysToDepartureDataPoints, function (rtpData, rtpKey) {
      var suffix = _.padStart(rtpKey, 5, '0');
      var fieldName1 = 'bookingMatrixField' + suffix;
      var fieldName2 = 'totalBookingsRtp' + suffix;
      var isCumulativeMode = bookingMatrixMode === 'bookingsCumulative';
      var isRtpPassed = _.toInteger(rtpKey) >= entry.currentRtp;
      var hasCumulativeValue = !_.isNull(rtpData.bookingsCumulative);
      lastCumulativeValue = isRtpPassed ? hasCumulativeValue ? rtpData.bookingsCumulative : lastCumulativeValue : null;
      newEntry[fieldName1] = isCumulativeMode ? lastCumulativeValue : rtpData[bookingMatrixMode] || (isRtpPassed ? 0 : null);
      newEntry[fieldName2] = lastCumulativeValue;
      var heatMapClass = HEAT_MAP_CLASS_NAME + getAvailThreshold(rtpData.classClosurePercentage);
      var cumulativeBookingsClass = isCumulativeMode && !hasCumulativeValue && CARRIED_OVER_VALUE_CLASS || '';
      _.set(newEntry, 'customClasses.' + fieldName1, [heatMapClass, cumulativeBookingsClass].join(' '));
    });
    return newEntry;
  }
  function getAvailThreshold(avail) {
    var result = 0;
    if (avail !== 0) {
      _.forEach(AVAILABILITY_THRESHOLDS, function (value, index) {
        if (avail <= value) {
          result = index;
          return false;
        }
      });
    }
    return result;
  }
  return {
    transformRtpData: transformRtpData,
    getAvailThreshold: getAvailThreshold
  };
};
BookingMatrixTransformationService.$inject = [];
module.exports = BookingMatrixTransformationService;